import React from 'react';
import { ModalProvider as ModalProviderRaw } from 'styled-react-modal';
import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import Div100vh from 'react-div-100vh';

const ModalBackground = styled(Div100vh)`
  display: flex;
  position: fixed;
  width: 100vw;
  z-index: 10500;
  background: #00000040;
  align-items: flex-end;
  justify-content: center;
  top: 0;

  ${media.sm`
    align-items: center;
  `}
`;

export const ModalProvider = (props) => (
  <ModalProviderRaw backgroundComponent={ModalBackground} {...props} />
);
